import { __awaiter, __generator } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, } from "@mui/material";
var EditTripModal = function (_a) {
    var open = _a.open, onClose = _a.onClose, trip = _a.trip, onSave = _a.onSave;
    var _b = useState((trip === null || trip === void 0 ? void 0 : trip.tripName) || ""), name = _b[0], setName = _b[1];
    var _c = useState(false), saving = _c[0], setSaving = _c[1];
    React.useEffect(function () {
        setName((trip === null || trip === void 0 ? void 0 : trip.tripName) || "");
    }, [trip]);
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!trip)
                        return [2 /*return*/];
                    setSaving(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, onSave(trip.tripId, { tripName: name })];
                case 2:
                    _a.sent();
                    onClose();
                    return [3 /*break*/, 4];
                case 3:
                    setSaving(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(Dialog, { open: open, onClose: onClose, fullWidth: true, maxWidth: "sm", children: [_jsx(DialogTitle, { children: "Edit Trip" }), _jsx(DialogContent, { children: _jsx(TextField, { fullWidth: true, label: "Trip Name", value: name, onChange: function (e) { return setName(e.target.value); }, sx: { mt: 1 } }) }), _jsxs(DialogActions, { children: [_jsx(Button, { onClick: onClose, disabled: saving, children: "Cancel" }), _jsx(Button, { onClick: handleSave, variant: "contained", disabled: saving, children: "Save" })] })] }));
};
export default EditTripModal;
